import TranslatedInputField, { type TranslatedInputFieldProps } from '../../../components/fields/TranslatedInputField';
import { InputContainer } from './shared';

const TranslatedInputFormField = (props: TranslatedInputFieldProps) => (
    <InputContainer>
        <TranslatedInputField {...props} />
    </InputContainer>
);

export default TranslatedInputFormField;
